import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";

export const ChiTietDongLai = ({
  hopdong,
  TongChiTietDongLaiShow,
  nhanvayId,
}) => {
  const searchInit = {
    nhanvayId: nhanvayId,
    pageIndex: 1,
    pageSize: 5,
  };
  const [dataSearchLanDongLai, UpdateDataSearchLanDongLai] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongBanGhi: 0,
    TongCanThanhToan: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongThanhToan: 0,
    TongTienGoc: 0,
    TongTienLai: 0,
  };
  const [dataLanDongLai, UpdateDataLanDongLai] = useState(dataInit);

  const DanhSachLanThanhToan = () => {
    NhanVayApi.lanThanhToan1(
      dataSearchLanDongLai.nhanvayId,
      dataSearchLanDongLai.pageIndex,
      dataSearchLanDongLai.pageSize
    ).then((response) => {
      UpdateDataLanDongLai({
        ...dataLanDongLai,
        List: response.data.List,
        TongBanGhi: response.data.TongBanGhi,
        TongCanThanhToan: response.data.TongCanThanhToan,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongThanhToan: response.data.TongThanhToan,
        TongTienGoc: response.data.TongTienGoc,
        TongTienLai: response.data.TongTienLai,
      });
      TongChiTietDongLaiShow(response.data.TongBanGhi.toString());
    });
  };
  //End fix height tab

  useEffect(() => {
    DanhSachLanThanhToan();
  }, []);

  const PhanTrang = (index) => {
    dataSearchLanDongLai.pageIndex = index;
    DanhSachLanThanhToan();
  };

  const listItem = () => {
    return (
      dataLanDongLai.List != null &&
      dataLanDongLai.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td>{item.STT}</td>
              <td className="text-left">{item.NgayTraLai}</td>
              <td className="text-right">{formatNumber(item.TienLai)}</td>
              <td className="text-right">{formatNumber(item.TienGoc)}</td>
              <td className="text-right">{formatNumber(item.PhiKhac)}</td>
              {/* <td className="text-right">{formatNumber(item.PhiKho)}</td> */}
              <td className="text-right">{formatNumber(item.DaThanhToan)}</td>
              <td className="text-right">
                {item.CacLanDong.map((item) => (
                  <>
                    <p className="text-center">
                      {formatNumber(item.TienThanhToan * -1)} (
                      <span className="date-sm">{item.ThoiGianThanhToan}</span>)
                    </p>
                  </>
                ))}
              </td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <>
      <div className="table-from-detailtl">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>STT</th>
                  <th className="text-left w-10">Ngày trả lãi</th>
                  <th className="text-right">
                    Tiền lãi
                    <br />  
                    <span className="red">
                      {formatNumber(dataLanDongLai.TongTienLai)}
                    </span>
                  </th>
                  <th className="text-right">
                    Tiền gốc
                    <br />  
                    <span className="red">
                      {formatNumber(dataLanDongLai.TongTienGoc)}
                    </span>
                  </th>
                  <th className="text-right">
                    Phí khác
                    <br />  
                    <span className="red">
                      {formatNumber(dataLanDongLai.TongPhiKhac)}
                    </span>
                  </th>
                  {/* <th className="text-right">
                    Phí kho
                    <br />  
                    <span className="red">
                      {formatNumber(dataLanDongLai.TongPhiKho)}
                    </span>
                  </th> */}

                  <th className="text-right">
                    Đã thanh toán <br />  
                    <span className="home-new-blue">
                      {formatNumber(dataLanDongLai.TongThanhToan)}
                    </span>
                  </th>
                  <th className="w-15 ">Các lần đóng</th>
                </tr>
              </thead>
              <tbody>{listItem()}</tbody>
            </table>
          </div>
        </div>
        <div className="footer-page-new">
          <div className="col-xl-12 col-lg-12">
            <div className="paniation-new d-flex just-end">
              <Pagination
                activePage={dataSearchLanDongLai.pageIndex}
                itemsCountPerPage={dataSearchLanDongLai.pageSize}
                totalItemsCount={dataLanDongLai.TongBanGhi}
                pageRangeDisplayed={5}
                onChange={PhanTrang}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
